export const KNOWLEDGE_BASE_URL =
  'https://knowledge-base.yieldbird.com/prebid-stack/prebid-analytics-adapters'
